export enum ConditionOperator {
  UNKNOWN_CONDITION_OPERATOR = 'UNKNOWN_CONDITION_OPERATOR',
  EMPTY = 'EMPTY',
  EXISTS = 'EXISTS',
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  ALWAYS = 'ALWAYS',
  NEVER = 'NEVER',
  PROJECT_HAS_NO_INACCESSIBLE_ASSETS = 'PROJECT_HAS_NO_INACCESSIBLE_ASSETS'
}
